(function (window, $) {
  if ($('.campaign-landing-main').length) {
    intiLanding();
  }

  function intiLanding() {
    $('.more-info-item a, a.arrow-down').click(function (e) {
      e.preventDefault();
      var linkTo = '#' + this.href.split('#').pop();
      var headerHeight = $('.header-container').height();
      var offset = 1;
      var scrollTo = $(linkTo).offset().top - headerHeight + offset;

      $('html, body').animate({
        scrollTop: scrollTo
      }, 500);
    });

    $('.campaign-landing-main .register-btn').on('click', function (e) {
      var ctaLocation = e.target.dataset.ctaLocation;

      var $btn = $(this);

      if ($btn.attr('data-is_user_authed') === '1') {
        SC.analytics.mp.sendEvent('Challenge_Spring19 - Register', 'navigation', {'CTA Location': ctaLocation}, ctaLocation);
      } else {
        SC.analytics.mp.logEvent('Challenge_Spring19 - Sign In', 'navigation');
      }
    });
  }
})(window, jQuery);
